import HasRole from "modules/5_view_helpers/HasRole";

import { createMenuItems, createCustomFormLinks } from "./helpers";
import getTrainingNav from "./MainNav/TrainingNav";
import getHireageNav from "./MainNav/HireagesNav";
import _ from "lodash";
import getAdministrationNav from "./MainNav/AdministrationNav";

const getMainNav = (project_id, main_nav_custom_forms_links, main_nav_menus, current_user) => {
  const {
    main_menu: main_menu_custom_forms,
    administration: administration_custom_forms,
    training: training_custom_forms,
    hireages: hireages_custom_forms,
    settings: settings_custom_forms,
  } = main_nav_custom_forms_links;

  const {
    main_menu: main_menu_menus,
    administration: administration_menus,
    training: training_menus,
    hireages: hireages_menus,
    settings: settings_menus,
  } = main_nav_menus;

  let items = [];

  const AdministrationNav = getAdministrationNav(administration_custom_forms, administration_menus);
  if (_.isNotEmpty(AdministrationNav)) {
    items.push(AdministrationNav);
  }

  const AddressBookRole = HasRole({ resource_type: "AddressBook::Company" });
  if (AddressBookRole) {
    items.push({
      icon: "fa fa-book",
      label: "Address Book",
      to: `/address_book`,
    });
  }
  const ProjectRoles = HasRole({ resource_type: "Project" });
  if (ProjectRoles) {
    items.push({
      icon: "fa fa-building",
      label: "Projects",
      to: `/projects`,
    });
  }

  const EmployeeRoles = HasRole({ resource_type: "Employee", name: ["create", "moderator"] });
  if (EmployeeRoles) {
    items.push({
      icon: "fa fa-users",
      label: "Employees",
      to: `/employees`,
    });
  }

  const CommunicationsRoles = HasRole({
    resource_type: "Project::Communication",
  });
  if (CommunicationsRoles) {
    items.push({
      icon: "fa fa-comments",
      label: "Communications",
      to: `/project/${project_id}/communications`,
    });
  }

  const DrawingOfficeModuleRole = HasRole([
    { resource_type: "Project::SiteDocumentRelease" },
    { resource_type: "Project::Drawing" },
    { resource_type: "DrawingOffice::DrawingType" },
  ]);
  if (DrawingOfficeModuleRole) {
    items.push({
      icon: "fa fa-pencil",
      label: "Drawing Office",
      to: `/drawing_office`,
    });
  }

  const TrainingNav = getTrainingNav(training_custom_forms, training_menus);
  if (_.isNotEmpty(TrainingNav)) {
    items.push(TrainingNav);
  }

  const HireagesNav = getHireageNav(hireages_custom_forms, hireages_menus);
  if (_.isNotEmpty(HireagesNav)) {
    items.push(HireagesNav);
  }

  const ProductionModule = HasRole({ name: "Production_Module_Access" });
  if (ProductionModule) {
    items.push({
      icon: "fa fa-cogs",
      label: "Production",
      to: `/production`,
      external: true,
    });
  }

  const QAModuleRole = HasRole({ name: "QA_Module_Access" });
  if (QAModuleRole) {
    items.push({
      icon: "fa fa-search",
      label: "Quality Assurance",
      to: `/qa`,
      external: true,
    });
  }

  const StoreModuleRole = HasRole({ name: "Store_Module_Access" });
  if (StoreModuleRole) {
    items.push({
      icon: "fa fa-shopping-cart",
      label: "Store",
      to: `/store`,
    });
  }

  const TWRRole = HasRole({ resource_type: "Project::Twr" });
  if (TWRRole) {
    items.push({
      icon: "fa fa-wrench",
      label: "Temporary Works Register",
      to: `/project/${project_id}/twrs`,
    });
  }

  const SettingsRoles = HasRole({ category: "Settings" });
  if (SettingsRoles || _.isNotEmpty(settings_custom_forms) || _.isNotEmpty(settings_menus) || current_user?.id === 1) {
    let settingsMenu = { icon: "fa fa-cog", label: "Settings", content: [] };
    const AddressBookRoles = HasRole({ resource_type: "AddressBook::Company" }) || HasRole({ resource_type: "AddressBook::Contact" });
    if (AddressBookRoles) {
      settingsMenu.content.push({ label: "Address Book", to: "/address_book" });
    }

    const DepartmentRoles = HasRole({ resource_type: "Department" });
    if (DepartmentRoles) {
      settingsMenu.content.push({ label: "Departments", to: "/departments" });
    }
    const InternalCompanyRoles = HasRole({ resource_type: "InternalCompany" });
    if (InternalCompanyRoles) {
      settingsMenu.content.push({ label: "Internal Companies", to: "/internal_companies" });
    }
    const PositionsRoles = HasRole({ resource_type: "Position" });
    if (PositionsRoles) {
      settingsMenu.content.push({ label: "Positions", to: "/positions" });
    }

    const PaintSettingsRoles = HasRole({ resource_type: "Paint::Product" });
    if (PaintSettingsRoles) {
      settingsMenu.content.push({ label: "Paint", to: "/paint/settings" });
    }

    if (HasRole("admin")) {
      settingsMenu.content.push({ label: "User Groups", to: "/user_groups" });
    }
    if (HasRole("admin")) {
      settingsMenu.content.push({ label: "Users", to: "/users" });
    }
    if (current_user?.id === 1) {
      settingsMenu.content.push({ label: "Page Views", to: "/page_views" });
    }

    settingsMenu.content = _.concat(settingsMenu?.content, createCustomFormLinks(settings_custom_forms), createMenuItems(settings_menus));
    items.push(settingsMenu);
  }

  const TriggersRole = HasRole({ resource_type: "Triggers" });
  if (TriggersRole) {
    items.push({
      icon: "fa-solid fa-gun",
      label: "Triggers",
      to: `/triggers`,
    });
  }

  items = _.concat(items, createCustomFormLinks(main_menu_custom_forms), createMenuItems(main_menu_menus));

  return items;
};

export default getMainNav;
